import { HtmlEditor } from "devextreme-react";
import { Item, Toolbar } from "devextreme-react/html-editor";
import { useEffect } from "react";
import { useSelector } from "react-redux";

export default function DescriptionHtmlEditor(props) {
  const {
    descriptionRef,
    // currentEmployeeNo
    currentEmployee,
  } = props;

  const descr = useSelector((state) => state.workRecord.descr);
  // const classifWork = useSelector((state) => state.workRecord.classifWork);

  //   const dispatch = useDispatch();

  const userInfo = useSelector((state) => state.userInfo);

  useEffect(() => {
    if (descriptionRef.current) {
      descriptionRef.current.instance.option("value", descr);
    }
  }, [descr]);

  //   const onValueChanged = (e) => {
  //     console.debug("[onValueChanged]");
  //     console.debug("e.value", e.value);

  //     if (e.value && classifWork) {
  //       dispatch(
  //         updateDescr({
  //           descr: e.value,
  //         })
  //       );
  //     }
  //   };

  return (
    <HtmlEditor
      id="workRecordDescription"
      ref={descriptionRef}
      // height={300}
      height={200}
      valueType={"html"}
      readOnly={
        userInfo.employeeNo == currentEmployee.employeeNo ? false : true
      }
      // defaultValue={descr}
      //   value={descr}
      //   onValueChanged={onValueChanged}
    >
      <Toolbar multiline={true}>
        <Item name="undo" />
        <Item name="redo" />
        <Item name="separator" />
        <Item
          name="size"
          acceptedValues={[
            "8pt",
            "10pt",
            "12pt",
            "14pt",
            "18pt",
            "24pt",
            "36pt",
          ]}
        />
        <Item
          name="font"
          acceptedValues={[
            "Arial",
            "Courier New",
            "Georgia",
            "Impact",
            "Lucida Console",
            "Tahoma",
            "Times New Roman",
            "Verdana",
          ]}
        />
        <Item name="separator" />
        <Item name="bold" />
        <Item name="italic" />
        <Item name="strike" />
        <Item name="underline" />
        <Item name="separator" />
        <Item name="alignLeft" />
        <Item name="alignCenter" />
        <Item name="alignRight" />
        <Item name="alignJustify" />
        <Item name="separator" />
        <Item name="orderedList" />
        <Item name="bulletList" />
        <Item name="separator" />
        <Item name="header" acceptedValues={[false, 1, 2, 3, 4, 5]} />
        <Item name="separator" />
        <Item name="color" />
        <Item name="background" />
        <Item name="separator" />
        <Item name="link" />
        <Item name="separator" />
        <Item name="clear" />
        <Item name="codeBlock" />
        <Item name="blockquote" />
        <Item name="separator" />
        <Item name="insertTable" />
        <Item name="deleteTable" />
        <Item name="insertRowAbove" />
        <Item name="insertRowBelow" />
        <Item name="deleteRow" />
        <Item name="insertColumnLeft" />
        <Item name="insertColumnRight" />
        <Item name="deleteColumn" />
      </Toolbar>
    </HtmlEditor>
  );
}
